/**
 * MAB API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Модель клиента макробанка для идентификации в почте
 */
export interface MailClient { 
    /**
     * Идентификатор
     */
    id?: number;
    /**
     * Полное название клиента
     */
    fullName?: string | null;
}

